import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1><img src="/elyna.png" alt="logo" height={200} /></h1>
      <h2>My Collections</h2>
      <p>That spark my joy.</p>
    </div>
  )
}

export default Title;